import { PostComments, validatePostComments } from "../../model/comments/PostComments.js";
import { Comment, validateComment } from "../../model/comments/Comment.js";
import { createArrayValidator } from "../../../packages/validator/validator.js";
import { requestGetJson } from "../../../packages/fetcher/fetcherFunctions.js";

/**
 * Requests post summaries from the backend.
 */
export const getPostComments = async () => {
  const data = await requestGetJson<PostComments[]>(`/api/comments/summaries`);
  return createArrayValidator(validatePostComments)(data);
};

/**
 * Requests one post comments.
 */
export const getComments = async (postId: string) => {
  const data = await requestGetJson<Comment[]>(`/api/post/${postId}/comments`);
  return createArrayValidator(validateComment)(data);
};

/**
 * Requests one comment.
 */
export const getComment = async (commentId: string) => {
  const data = await requestGetJson<Comment[]>(`/api/comment/${commentId}`);
  return validateComment(data);
};
